import React, { Component } from "react";
import ICON from "../icons.js";

/* ============================================================================
 * HomeFaq — คำถามที่พบบ่อย (พับ/กางทีละข้อ)
 * เปิดค้างได้ทีละข้อ เพื่อไม่ให้หน้ายาวจนหาข้อถัดไปไม่เจอ
 * ========================================================================== */
export default class HomeFaq extends Component {
    state = { open: 0 };

    render() {
        const { items = [] } = this.props;
        if (!items.length) return null;
        const { open } = this.state;

        return (
            <section className="hm-section" id="hm-faq">
                <div className="hm-container">
                    <div className="hm-section__head hm-section__head--tight">
                        <h2 className="hm-section__title hm-section__title--sm">คำถามที่พบบ่อย</h2>
                    </div>

                    <div className="hm-faqs">
                        {items.map((item, index) => (
                            <div key={item.uid} className={`hm-faq ${open === index ? "is-open" : ""}`}>
                                <button
                                    type="button"
                                    className="hm-faq__q"
                                    onClick={() => this.setState({ open: open === index ? -1 : index })}
                                >
                                    <span>{item.title}</span>
                                    <span className="hm-ico">{open === index ? ICON.chevron_up : ICON.chevron_down}</span>
                                </button>
                                {open === index && <p className="hm-faq__a">{item.body}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }
}
